import { Typography, TypographyProps } from '@mui/material';
import hljs from 'highlight.js';
import { useEffect } from 'react';
import he from 'he';

const escapeHtmlCharsInCodeBlock = (value: string): string => {
  const regex = /<code[^>]*?>([\s\S]*?)<\/code>/gi;

  const resultValue = value.replace(regex, (match, content) => {
    const decodedContent = he.decode(content);
    const encodedContent = he.encode(decodedContent);
    return match.replace(content, encodedContent);
  });

  return resultValue;
};

interface MarkdownFormatterProps extends TypographyProps {
  text: string;
}

const TextFormatter = ({ text, ...props }: MarkdownFormatterProps) => {
  const normalizedText = escapeHtmlCharsInCodeBlock(
    text
      .replace(/\\n/g, '\n')
      .replaceAll(/\s*class="[^"]*"/g, '')
      .replaceAll(/\s*width="[^"]*"/g, '')
      .replaceAll(/\s*height="[^"]*"/g, '')
      .replaceAll(/\s*style="[^"]*"/g, ''),
  );

  useEffect(() => {
    hljs.highlightAll();
  }, []);

  return (
    <Typography
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      sx={{ whiteSpace: 'pre-wrap', '& img': { maxWidth: '100%', height: 'auto' } }}
      dangerouslySetInnerHTML={{ __html: normalizedText }}
    />
  );
};

export default TextFormatter;
